import { positionStats, type GameState, type Move } from '@qlashgeminiz/qgammon-rules';

import { formatPly } from '@/lib/qgammon/notation';
import type { PositionStatsView, PositionView } from '@/types/myBoards';

/**
 * Le mosse candidate arrivano dal server come `Move[]`, NON come stringhe (`/analysis`, forme precisate di myboards-orcb): la
 * notazione la scrive la TMA con la STESSA funzione dello storico e del replay (`lib/qgammon/notation.ts`, `formatPly`) — una
 * seconda notazione divergerebbe alla prima revisione.
 */

/** La posizione di un board come `GameState` del motore, per darla a chi parla quella lingua. Nessun calcolo: solo i campi. */
export function gameStateDa(position: PositionView): GameState {
  return {
    points: position.points,
    bar: position.bar,
    off: position.off,
    turn: position.turn,
    dice: position.roll ? [...position.roll] : [],
    lastRoll: position.roll,
    // Un cubo ignoto (`value: null`) non e' un dato: il motore vuole un numero e qui non serve a niente (ne' `positionStats` ne'
    // la notazione lo leggono), quindi 1 e' un segnaposto del TIPO, mai mostrato.
    cube: { value: position.cube.value ?? 1, owner: position.cube.owner, crawford: position.crawford },
    phase: position.phase,
    winner: null,
    winMagnitude: 0,
  };
}

/** Una mossa candidata in notazione («bar/23 13/7»), dal punto di vista di chi e' di turno nella posizione del board. */
export function notazioneCandidata(moves: readonly Move[], position: PositionView): string {
  return formatPly(moves, position.turn, gameStateDa(position));
}

/**
 * L'aritmetica di una posizione (ADR-0191 §5 classe i): `positionStats` del motore, UNA funzione per TMA e web — la riga della
 * lista e la scheda leggono lo stesso numero. Sincrona, nel client: una chiamata per riga non esiste.
 */
export function statsDi(position: PositionView): PositionStatsView {
  return positionStats(gameStateDa(position));
}
